// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

// Place any jQuery/helper plugins in here.


/*!
* mqGenie v0.5.0
*
* Adjusts CSS media queries in browsers that include the scrollbar's width in the viewport width so they fire at the intended size
*
* Returns the mqGenie object containing .adjusted, .width & fontSize for use in re-calculating media queries in JavaScript with mqAdjust(string)
*
* Copyright (c) 2014 Matt Stow
*
* http://mattstow.com
*
* Licensed under the MIT license
*/
;(function(window, document) {
    if (!document.addEventListener) {
        window.mqGenie = {
            adjustMediaQuery: function(mediaQuery) {
                return mediaQuery;
            }
        }

        return;
    }

    function processRules(stylesheet, processor) {
        var rules = stylesheet.cssRules ? stylesheet.cssRules : stylesheet.media,
            rule,
            processed = [],
            i = 0,
            length = rules.length;

        for (i; i < length; i ++) {
            rule = rules[i];

            if (processor(rule))
                processed.push(rule);
        }

        return processed;
    }

    function getMediaQueries(stylesheet) {
        return processRules(stylesheet, function (rule) {
            return rule.constructor === CSSMediaRule;
        });
    }

    function sameOrigin(url) {
        var loc = window.location,
            a = document.createElement('a');

        a.href = url;

        return a.hostname === loc.hostname && a.protocol === loc.protocol;
    }

    function isInline(stylesheet) {
        return stylesheet.ownerNode.constructor === HTMLStyleElement;
    }

    function isValidExternal(stylesheet) {
        return stylesheet.href && sameOrigin(stylesheet.href);
    }

    function getStylesheets() {
        var sheets = document.styleSheets,
            sheet,
            length = sheets.length,
            i = 0,
            valid = [];

        for (i; i < length; i++) {
            sheet = sheets[i];

            if (isValidExternal(sheet) || isInline(sheet))
                valid.push(sheet);
        }

        return valid;
    }

    document.addEventListener('DOMContentLoaded', function() {
        window.mqGenie = (function() {
            var html = document.documentElement;

            html.style.overflowY = 'scroll';

            var width = window.innerWidth - html.clientWidth,
                props = {
                    adjusted: width > 0,
                    fontSize: parseFloat(window.getComputedStyle(html).getPropertyValue('font-size')),
                    width: width,
                    adjustMediaQuery: function(mediaQuery) {
                        if (!mqGenie.adjusted)
                            return mediaQuery;

                        var mq = mediaQuery.replace(/\d+px/gi, function(c) {
                            return parseInt(c, 10) + mqGenie.width + 'px';
                        });

                        mq = mq.replace(/\d.+?em/gi, function(c) {
                            return ((parseFloat(c) * mqGenie.fontSize) + mqGenie.width) / mqGenie.fontSize + 'em';
                        });

                        return mq;
                    }
                };

            if (props.adjusted) {
                if ('WebkitAppearance' in html.style) {
                    var chromeRX = /Chrome\/(\d*?\.\d*?\.\d*?\.\d*?)\s/g,
                        chrome = navigator.userAgent.match(chromeRX),
                        chromeVersion;

                    if (chrome) {
                        chrome = chrome[0].replace(chromeRX, '$1');
                        chromeVersion = chrome.split('.');
                        chromeVersion[0] = parseInt(chromeVersion[0]);
                        chromeVersion[2] = parseInt(chromeVersion[2]);
                        chromeVersion[3] = parseInt(chromeVersion[3]);

                        if (chromeVersion[0] <= 29) {
                            if (chromeVersion[0] === 29 && chromeVersion[2] < 1548 && chromeVersion[3] < 57) {
                                props.adjusted = false;
                            }
                            else if (chromeVersion[0] < 29) {
                                props.adjusted = false;
                            }
                        }
                    }
                    else {
                        props.adjusted = false;
                    }

                    if (!props.adjusted)
                        return props;
                }

                var stylesheets = getStylesheets(),
                    stylesheetsLength = stylesheets.length,
                    i = 0,
                    mediaQueries,
                    mediaQueriesLength;

                for (i; i < stylesheetsLength; i++) {
                    mediaQueries = getMediaQueries(stylesheets[i]);
                    mediaQueriesLength = mediaQueries.length;

                    for (var j = 0; j < mediaQueriesLength; j++) {
                        mediaQueries[j].media.mediaText = mediaQueries[j].media.mediaText.replace(/m(in|ax)-width:\s*(\d|\.)+(px|em)/gi, function(strA) {
                            if (strA.match('px')) {
                                return strA.replace(/\d+px/gi, function(strB) {
                                    return parseInt(strB, 10) + props.width + 'px';
                                });
                            }
                            else {
                                return strA.replace(/\d.+?em/gi, function(strB) {
                                    return ((parseFloat(strB) * props.fontSize) + props.width) / props.fontSize + 'em';
                                });
                            }
                        });
                    }
                }
            }

            return props;
        })();
    });
})(window, document);


var $testata = $('.no-touchevents .testata__bg'),
    $testataExternal = $('.no-touchevents .testata__bg-external'),
    $container = $('.no-touchevents .testata');

var altezzaTestata = $container.height();

var topScrollata = 0;

$('.quote').css('background-position', '50% 0');


$(window).on('load scroll', function(){

    scrollata = $(window).scrollTop();

    var perc = 1 - scrollata / $(window).height();

    if (perc <= 0) perc = 0;

    $testataExternal.css({transform: 'translateY(' + scrollata / 3 + 'px)', opacity: perc});

    // Apparizione tarda o scroll up di alcuni elementi

    $('.js-hide').each( function(i){

        $this = $(this);
        var middle_of_object = $this.offset().top + $this.outerHeight() / 4;
        var bottom_of_window = scrollata + $(window).height();

        if (bottom_of_window > middle_of_object || $this.hasClass('js-hide-little')) {

            $this.addClass('show');

        }

    });


    // Parallax della citazione

    $('.quote').each( function(i){

        $this = $(this);
        var top_of_object = $this.offset().top;
        var bottom_of_window = scrollata + $(window).height();
        var local_scroll = bottom_of_window - top_of_object;
        var total_scroll = $this.outerHeight() + $(window).height();
        var actual_scroll = local_scroll * 100 / total_scroll;

        if (bottom_of_window > top_of_object) {

            $this.css('background-position', '50% ' + actual_scroll + '%');

        }

    });


    // Apparizione del logo CrossCast

    $('.js-cs').each( function(i){

        $this = $(this);
        var top_of_object = $this.offset().top;
        var bottom_of_window = scrollata + $(window).height();

        if (bottom_of_window > top_of_object) {

            if (topScrollata == 0) {

                topScrollata = $this.offset().top - $(window).height();

            }

            newTrans = 550 - (scrollata - topScrollata) * 3;

            if (newTrans < 0) newTrans = 0;

            $this.css('transform', 'translateY(' + newTrans + 'px)').addClass('show');



        } else {
            $this.css('transform', 'translateY(550px)').removeClass('show');
        }
    });

});


// Gestione link ancore

$('a[href*="#"]:not([href="#"])').click(function() {
if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  var target = $(this.hash);
  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
  if (target.length) {
    $('html, body').animate({
      scrollTop: target.offset().top
    }, 1000);
    return false;
  }
}
});


// Effetto su testata

if ((Modernizr.csstransforms3d || Modernizr.csstransforms) && typeof TweenMax !== "undefined") {  // Il movimento solo se ci sono le trasformate e ovviamente se ha caricato il plugin

    $container.on('mousemove.parallax', function(e) {

        var pos_x = e.pageX,
            pos_y = e.pageY,
            translateTestata = "",
            left = $container.width()  / 2 - pos_x,
            top  = $container.height() / 2 - pos_y;

        if (Modernizr.csstransforms3d) {  // Se ci sono le 3d, meglio
            translateTestata = 'translate3d(' + left / 100 + 'px, ' + top / 80 + 'px, 0)'

        } else {
            translateTestata = 'translateX(' + left / 100 + 'px) translateY(' + top / 80 + 'px)';
        }

        TweenMax.to(
            $testata, 1, {
                transform: translateTestata,
                ease: Expo.easeOut,
                overwrite: 'all'
            }
        );

    });

}

$('.js-menu').on('click', function(e) {
    e.preventDefault();
    $('.header').toggleClass('header--menu');
})



$('.js-hover a').hover(function() {
    $(this).parents('.js-hover').addClass('hover');

}, function() {
    $(this).parents('.js-hover').removeClass('hover');
});


if ($('.swiper-container').length) {
    var swiper;

    $(window).on('load resize', function(){

       var ww = $(window).width();

        if (ww <= 768) {
            if (swiper) return;
            else swiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                spaceBetween: 50,
                grabCursor: true
            });
        } else {
            if (swiper) {
                swiper.destroy();
                $('.swiper-container, .swiper-slide, .swiper-wrapper').removeAttr('style');
                swiper = undefined;
            }
        }

    });
}

